import { FILTER_RESPONSE, SearchFilterActions, } from '../actions/search-filter.actions';

export interface State {
  lastQueryForAgents: string;
  lastQueryForConcepts: string;
  filteredAgents: any[];
  filteredConcepts: any[];
}

export const initialState: State = {
  lastQueryForAgents: '',
  lastQueryForConcepts: '',
  filteredAgents: [],
  filteredConcepts: [],
};

export function reducer(state = initialState, action: SearchFilterActions): State {
  switch (action.type) {
    case FILTER_RESPONSE: {
      if (action.payload.asset === 'agent') {
        return {
          ...state,
          filteredAgents: action.payload.filteredAssets,
        };
      } else if (action.payload.asset === 'concept') {
        return {
          ...state,
          filteredConcepts: action.payload.filteredAssets,
        };
      } else {
        return state;
      }
    }

    default: {
      return state;
    }
  }
}

export const getFilteredAgents = (state: any) => {
  return (state.searchFilter && state.searchFilter.filteredAgents) ? state.searchFilter.filteredAgents : [];
};
export const getFilteredConcepts = (state: any) => {
  return (state.searchFilter && state.searchFilter.filteredConcepts) ? state.searchFilter.filteredConcepts : [];
};
